import axios from "../../libs/httpClient";
import { host } from "../../libs/webRTC";

export async function ldapstatus() {
    try {
        const response = await axios.get(`${host}/ldap/ldapsyncstatus`);
        return response.data;
    } catch (error) {
        console.error('ldapsyncstatus failed:', error);
        throw error;
    }
}

export async function ldapsync(password) {
    try {
        const response = await axios.post(`${host}/ldap/ldapsync`, { password }, { timeout: 0 });
        return response.data;
    } catch (error) {
        console.error('ldapsync failed:', error);
        throw error;
    }
}
